const Store = require('./store');
const createReducer = Store.createReducer;
const DEBUG = process.env.NODE_ENV !== 'production';

/**
   * Make a trigger into a function for the API.
   * @param {object} store - the state store.
   * @param {function} trigger - original trigger function.
   * @param {string} triggerPath - namespaced trigger name.
   * @return {function} - trigger function ready to be used by the API.
   */
const makeFunctionForAPI = (store, trigger, triggerPath) => {
  const getState = store.getState;
  const dispatch = (action) => {
    if (typeof action !== 'object' || Array.isArray(action)) {
      throw new TypeError('Expected action to be an object');
    }
    action.meta = action.meta || {};
    action.meta.trigger = triggerPath;
    if (DEBUG) console.log(`dispatching ${action.type} from ${triggerPath}`);
    return store.dispatch(action);
  };
  return (...args) => {
    if (DEBUG) console.log(`running ${triggerPath} ...`);
    // FIXME: can't use rest args
    return Promise.resolve(trigger(dispatch, getState, ...args))
    .then((result) => {
      if (DEBUG) console.log(`${triggerPath} done.`);
      if (DEBUG) console.log('new state:', getState());
      return result;
    });
  };
};

const makeTriggerForAPI = (/*store, trigger, triggerPath*/) => {
  // TODO:
};

/**
   * Create the API from store and triggers.
   * @param {object} store - the state store.
   * @param {object} triggers - triggers grouped by namespace.
   * @param {object} extenders - extra functions for the API.
   * @return {object} - API object.
   */
const createAPI = (store, triggers={}, extenders={}) => {
  // enhance getState
  const _getState = store.getState;
  store.getState = (namespace) => {
    if (!namespace) return _getState();
    if (Object.keys(_getState()).indexOf(namespace) >= 0) {
      return _getState()[namespace];
    }
    else throw new Error(`Invalid namespace "${namespace}".`);
  };
  const api = {
    get store() { return store; },
  };
  for (let name in triggers) {
    if (typeof triggers[name] === 'function') {
      const trigger = triggers[name];
      const triggerPath = name;
      api[name] = makeTriggerForAPI(store, trigger, triggerPath);
    } else if (triggers[name].constructor === Object) {
      // handle namespace
      api[name] = api[name] || {};
      for (let triggerName in triggers[name]) {
        const trigger = triggers[name][triggerName];
        const triggerPath = name + '.' + triggerName;
        api[name][triggerName] = makeFunctionForAPI(store, trigger, triggerPath);
      }
    } else throw new Error('Invalid triggers.');
  }
  for (let name in extenders) {
    if (typeof extenders[name] === 'function') {
      // const extender = extenders[name];
      api[name] = extenders[name](api);
    } else if (extenders[name].constructor === Object) {
      // handle namespace
      api[name] = api[name] || {};
      for (let extenderName in extenders[name]) {
        // const extender = extenders[name][extenderName];
        api[name][extenderName] = extenders[name][extenderName](api);
      }
    } else throw new Error('Invalid extenders.');
  }
  api.getState = store.getState;
  api.subscribe = store.subscribe;
  return api;
};

/**
  * Build an application api.
  * @param {object} config - define state, handlers and triggers.
  * @return {object} - api object.
  */
const buildAPI = ({
  state = {},
  handlers,
  triggers,
  extenders,
  createStore,
  enhancer,
}) => {
  createStore = createStore || Store.createStore;
  const reducer = createReducer(handlers);
  const store = createStore(reducer, state, enhancer);
  const api = createAPI(store, triggers, extenders);
  return api;
};

/**
   * create a flux standard action.
   * @param {string} type - type of action.
   * @param {any} payload - optional payload for the action.
   * @param {object} params - optional meta information for the action.
   * @return {object} - flux standard action.
   */
const makeAction = (type, payload, meta) => {
  if (typeof type !== 'string') throw new TypeError('type must be a string');
  return {type, payload, meta};
};

module.exports = {createAPI, createReducer, buildAPI, makeAction};



// WEBPACK FOOTER //
// ../rex/lib/rex.js